const HelpIcon = (color: any) => {
  return (
    <svg
      className="mx-7"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_589_11416)">
        <mask
          id="mask0_589_11416"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <path d="M24 0H0V24H24V0Z" fill={color?.color} />
        </mask>
        <g mask="url(#mask0_589_11416)">
          <path
            d="M12 0C5.36761 0 0 5.367 0 12C0 18.6323 5.367 24 12 24C18.6324 24 24 18.633 24 12C24 5.36761 18.633 0 12 0ZM12 22.3256C6.30647 22.3256 1.67442 17.6936 1.67442 12C1.67442 6.30642 6.30647 1.67442 12 1.67442C17.6936 1.67442 22.3256 6.30642 22.3256 12C22.3256 17.6936 17.6936 22.3256 12 22.3256Z"
            fill={color?.color}
          />
          <path
            d="M11.6448 15.1836C10.9814 15.1836 10.4443 15.7364 10.4443 16.3998C10.4443 17.0475 10.9656 17.6161 11.6448 17.6161C12.324 17.6161 12.861 17.0475 12.861 16.3998C12.861 15.7364 12.3082 15.1836 11.6448 15.1836Z"
            fill={color?.color}
          />
          <path
            d="M11.85 5.97559C9.71759 5.97559 8.73828 7.23929 8.73828 8.09223C8.73828 8.70826 9.25953 8.9926 9.686 8.9926C10.539 8.9926 10.1915 7.77629 11.8026 7.77629C12.5924 7.77629 13.2243 8.12382 13.2243 8.85043C13.2243 9.70337 12.3397 10.193 11.8184 10.6353C11.3603 11.0301 10.7601 11.6778 10.7601 13.0362C10.7601 13.8576 10.9813 14.0945 11.6289 14.0945C12.4028 14.0945 12.5608 13.747 12.5608 13.4469C12.5608 12.6255 12.5766 12.1516 13.4454 11.4724C13.8718 11.1407 15.2144 10.0666 15.2144 8.58184C15.2144 7.09707 13.8718 5.97559 11.85 5.97559Z"
            fill={color?.color}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_589_11416">
          <rect width="24" height="24" fill={color?.color} />
        </clipPath>
      </defs>
    </svg>
  );
};
export default HelpIcon;
